export const GA_MOBILE_REF: Record<number, string> = {
  0: "home-grouped-story-1",
  1: "home-top-stories-3",
  2: "home-top-stories-4",
  3: "home-top-stories-5",
  4: "home-top-stories-6",
  5: "home-top-stories-1",
  6: "home-top-stories-2",
  7: "home-top-stories-7",
  8: "home-top-stories-8",
};
